@if (visible$ | async) {
<a [routerLink]="productURL$ | async" queryParamsHandling="merge" class="btn btn-primary" role="button">
  {{ 'product.choose_variation.link' | translate }}
</a>
}
